<ng-container *ngIf="labelKey === 'NEXT'" i18n>Weiter</ng-container>
<ng-container *ngIf="labelKey === 'SAVE'" i18n>Speichern</ng-container>
